// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> harrington-trail
// Generated: 2026-10-30T17:48:37.661Z
// Counts: 3 design, 47 content, 50 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "VALUE",
    "value": "#1d9446",
    "mappedField": null
  },
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#224f46",
    "mappedField": null
  },
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "VALUE",
    "value": "#1d9446",
    "mappedField": null
  }
};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Next Rental Home in Greenville, SC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Next Home at Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility at Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities at Harrington Trail in Greenville, SC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At home you get smart-home tech, in-unit laundry, and a fenced backyard, and we take care of the lawn. Around the community there's an Olympic-size lap pool, a clubhouse, a fire pit patio, and a playground. <a href=\"/amenities\">See all amenities</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, fire pit nights</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cool off in the Olympic-size lap pool, unwind by the fire pit, let the kids loose on the playground, or gather at the clubhouse and covered cabana—all just a short walk from your front door.</p>",
    "mappedField": null
  },
  "amenityhighlights.title": {
    "overrideType": "VALUE",
    "customValue": "<p>The Little Extras That Make a Difference</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aroundthearea.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Get to Know Your New Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactdetails.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Our Leasing Team in Greenville, SC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhelp.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything You'd Like to Know About Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqsearch.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Harrington Trail Frequently Asked Questions</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter change, exterior pest control, 24-hour maintenance response on emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Harrington Trail Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Harrington Trail: Modern Homes for Rent in Greenville, SC</p>",
    "generatedValue": "<p>Brand-new 3- and 4-bedroom rental homes in Greenville</p>",
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Available Rental Homes in Greenville, SC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Harrington Trail, the shared spaces fit into a normal week: laps or a lazy afternoon at the pool, evenings at the fire pit patio, and a playground and clubhouse just down the street. Take a look at all the <a href=\"/amenities\">community amenities</a>.</p>",
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living Near Downtown Greenville at Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pollyanna Drive sits on Greenville's south side, near the trails along the Reedy River at Conestee. Downtown Greenville, Mauldin, and the Michelin and GE Vernova job centers are an easy drive away. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Quiet streets near Conestee and Greenville</p>",
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet-Friendly Rental Homes at Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.glance_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Fees, Pet Rent, and Guidelines</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Every home comes with a fenced backyard, so pets can get outside easily, and lawn care is included. When you want a longer walk, the Swamp Rabbit Trail and Conestee Nature Preserve are both a short drive away—see more in <a href=\"/neighborhood\">the neighborhood</a>.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room for pets to roam</p>",
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Harrington Trail Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Next Home in Greenville, SC 29605</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for contacting Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyou.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We Look Forward to Connecting With You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourgallery.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Place in Greenville at Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Self-Guided Tour of Harrington Trail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Browse our <a href=\"/gallery\">photo gallery</a> to get a feel for each plan, then see a home in person on your own schedule with a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "touroptions.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare the Brunswick, Guilford, and Kershaw Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tours-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3D Virtual Tours of Harrington Trail Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pick a tour to look around Harrington Trail's three- and four-bedroom homes at your own pace, then <a href=\"/schedule-a-tour\">book a self-guided tour</a> when you're ready to see one in person.</p>",
    "mappedField": null
  },
  "virtualtourembed.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Every Floor Plan from Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-3658-71fc-9e9f-8e86dcd7a6f9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Harrington Trail's outdoor pool with lounge chairs and the clubhouse behind it"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-e60f-7265-bec5-9b640c92cc01.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community playground with slides and a swing set"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-36c3-773a-9a6a-540570e85898.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the clubhouse and its poolside lounge chairs and seating areas"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Fire Pit Area"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-36c7-732d-8f0e-9c975aa25bbe.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor fire pit area with Adirondack chairs and landscaping"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ea66-7223-9210-5f6ef1ebe462.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Harrington Trail's fenced swimming pool with lounge chairs and landscaping"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-36de-738a-a8d2-0daaa07e7078.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a swimming pool, playground, and clubhouse at a multifamily property."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f776-7459-a047-90e3c56be530.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with a large island, granite countertops, and stainless steel appliances"
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ea66-7223-9210-5f6ef1ebe462.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced community swimming pool with lounge chairs and landscaping"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lap Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f15f-752a-8498-253187281488.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fire pit patio with chairs arranged around it"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Fire Pit"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-357f-74f7-95dd-0df81c5abf41.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Children's playground with slides and climbing structures."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-3658-71fc-9e9f-8e86dcd7a6f9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse behind the pool deck with lounge chairs"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-41e3-70ed-bdca-53b596c81bf1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Harrington monument sign with landscaping."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Entrance"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ef78-758f-bc87-caffcc4aa089.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of homes, manicured lawns, and curving neighborhood streets"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood"
      }
    }
  },
  "feetable.situational_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "$30"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-a7af-72bb-b541-4455515d0ea1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story Harrington Trail rental home with blue siding, brick accents, and a two-car garage"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c352-77a9-a65d-3a3444516a70.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White single-family rental home with a two-car garage"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f776-7459-a047-90e3c56be530.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with a large island, granite countertops, and stainless steel appliances"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ea66-7223-9210-5f6ef1ebe462.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community swimming pool with lounge chairs and landscaping at Harrington Trail"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c1e8-72d9-8633-0126957ad072.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gray two-story home with a front porch, attached garage, and lawn"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-fe50-76ae-b61f-8cfb9d158fdf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living and dining area flowing into a kitchen with an island"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f15f-752a-8498-253187281488.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community fire pit patio with outdoor seating"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ef78-758f-bc87-caffcc4aa089.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Harrington Trail homes, lawns, and curving streets"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-d97b-736f-ab86-dfa13b002583.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the community pool, clubhouse, and playground"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167633/01a11690-795b-71b4-832d-a5c8f9853572.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living room and kitchen with a blue accent chair, sofa, and island with bar stools."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside downtime"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Swim laps in the Olympic-size pool, then find some shade under the covered cabana."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fire pit evenings"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighbors gather around the fire pit patio after dinner while the kids burn off energy at the community playground."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse time"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "When you need a break from the house, the community clubhouse is right in the neighborhood, steps from the pool."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-9531-7428-8100-157ee8a9c4c9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Wetlands and trails at Conestee Nature Preserve near Harrington Trail"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Conestee Nature Preserve"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-d329-73c3-bd68-c4ed52e0e6bd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Back of a home with a spacious grassy backyard"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Your own backyard"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c1e8-72d9-8633-0126957ad072.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story gray rental home with a front porch, attached garage, and lawn"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Single-Family Homes"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-fe50-76ae-b61f-8cfb9d158fdf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living and dining area flowing into a kitchen with an island and stainless appliances"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open Living Area"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f776-7459-a047-90e3c56be530.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious kitchen featuring a large island with a double sink, granite countertops, and stainless steel appliances, perfect for cooking and entertaining."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchen"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f15f-752a-8498-253187281488.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community fire pit patio with chairs arranged around it"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fire Pit Patio"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-d97b-736f-ab86-dfa13b002583.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the community pool, clubhouse, and playground"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pool & Clubhouse"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ef78-758f-bc87-caffcc4aa089.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "An aerial perspective of a newly developed neighborhood, showcasing houses, manicured lawns, and curving streets."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "greeted by the staff with a warm welcome"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Quick maintenance"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "Maintenance requests have been addressed quickly."
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Friendly neighbors"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "All of my neighbors are so friendly."
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Easy leasing"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "The process to rent was easy"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Community pool"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "The park and pool is a plus."
      }
    }
  },
  "reviewthemes.chip_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Calm & quiet"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "A safe, quiet place to live."
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-a7af-72bb-b541-4455515d0ea1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story rental home with blue siding, brick accents, and a white two-car garage"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
